/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, Fragment, useRef } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import ReCAPTCHA from "react-google-recaptcha";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import Consent from "./Consent";
import {
  SvgIconUsers,
  SvgIconCalendar,
  SvgIconTime,
  SvgIconStethoscope,
  SvgIconDefaultArrow
} from "./SvgLib";
import { ActionCreators } from "../actions";
import closeButtonImg from '../assets/images/close_button.png';
import { formatPhoneNumber } from "../utils";

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const { REACT_APP_RECAPTCHA_KEY } = process.env;

function SoonestSlotsProvidersDialog(props) {
  const recaptchaRef = useRef();
  const [showDialog, setShowDialog] = useState(false);
  const closeDialog = () => setShowDialog(false);
  const openDialog = () => {
    setShowDialog(true);
  };
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const [state, setState] = useState({
    checked_info: false,
    checked_age: false,
    checked_in_colorado: false,
    consent_forms: false,
    reminderType: "",
    contactValue: "",
    screen_Schedule: true,
    screen_Reminder: false,
    intervalId: 0,
    recaptcha: false,
    state_dialog_ReminderSnapchat: false,
    state_dialog_ReminderEmail: false,
    state_dialog_ReminderTextMessage: false,
    applicant_nickname: "",
    applicant_snapchat: "",
    applicant_email: "",
    applicant_phone: "",
    applicant_preferred_language: "English",
    other_preferred_language: "",
    state_dialog_ConfirmedMessage: false
  });

  const submitAppointment = () => {
    setState(prevState => {
      const updatedState = {
        ...prevState,
        locationAddress: props.selectedSlotData.locationAddress,
        reminded: false,
        reminderValue: props.selectedSlotData.providerName,
        bringingFriend: props.selectedSlotData.onehour,
        locationID: props.selectedSlotData.locationID,
        provider: props.selectedSlotData.providerID,
        timeslotID: props.selectedSlotData.slotkey,
        appointmentTimestamp: Date.now()
      };

      const name = updatedState.applicant_nickname;
      const locationAddress = updatedState.locationAddress;
      const phone = updatedState.applicant_phone;
      const language =
        updatedState.applicant_preferred_language === "Other"
          ? updatedState.other_preferred_language
          : updatedState.applicant_preferred_language;
      const reminded = false;
      const reminderType = updatedState.reminderType;
      const reminderValue = updatedState.reminderValue;
      const bringingFriend = updatedState.bringingFriend;
      const locationID = updatedState.locationID;
      const provider = updatedState.provider;
      const timeslotID = updatedState.timeslotID;
      const appointmentTimestamp = updatedState.appointmentTimestamp;
      const appointmentTimeQuery = {
        start: moment(props.selectedSlotData.durationStart).valueOf(),
        end: moment(props.selectedSlotData.durationEnd).valueOf()
      };
      const contactValue = updatedState.contactValue;

      props.f_CREATE_Appointment(
        name,
        locationAddress,
        phone,
        language,
        reminded,
        reminderType,
        reminderValue,
        bringingFriend,
        locationID,
        provider,
        timeslotID,
        appointmentTimestamp,
        appointmentTimeQuery,
        contactValue
      );

      return updatedState;
    });
  };

  const dialogChooseReminder = () => {
    const {
      recaptcha,
      checked_age: age,
      checked_in_colorado: inColorado,
      consent_forms: consentForms,
      checked_info: info,
      applicant_nickname: name,
      applicant_phone: phone,
      applicant_preferred_language: applicantLanguage,
      other_preferred_language: language
    } = state;

    const isOtherLanguage = applicantLanguage === "Other";

    if (!info) {
      setState(prevState => ({
        ...prevState,
        rField: `Is this information correct?`
      }));
    } else if (!age) {
      setState(prevState => ({
        ...prevState,
        rField: `Applicants must be between 13 - 25 years old`
      }));
    } else if (!inColorado) {
      setState(prevState => ({
        ...prevState,
        rField: `Applicants must be in Colorado`
      }));
    } 
    else if (!consentForms) {
      setState(prevState => ({
        ...prevState,
        rField: `Consent forms are required to proceed.`
      }));
    }
    else if (!recaptcha) {
      setState(prevState => ({
        ...prevState,
        rField: `Please check "I'm not a robot" checkbox`
      }));
    } else if (!phone) {
      setState(prevState => ({
        ...prevState,
        rField: `Please enter your phone number`
      }));
    } else if (phone.length < 10) {
      setState(prevState => ({
        ...prevState,
        rField: `Please enter a valid phone number`
      }));
    } else if (!name || name === "") {
      setState(prevState => ({
        ...prevState,
        rField: `Please enter your name or nickname`
      }));
    } else if (isOtherLanguage && language === "") {
      setState(prevState => ({
        ...prevState,
        rField: `Please enter a valid language`
      }));
    }

    if (
      recaptcha &&
      age &&
      inColorado &&
      consentForms &&
      info &&
      phone &&
      name !== "" &&
      phone.length > 9 &&
      (!isOtherLanguage || (isOtherLanguage && language !== ""))
    ) {
      setState(prevState => ({
        ...prevState,
        state_dialog_ConfirmedMessage: true,
        animate_screen_Schedule: true,
        screen_Reminder: true
      }));

      setTimeout(() => {
        setState(prevState => ({
          ...prevState,
          state_dialog_ConfirmedMessage: true,
          screen_Schedule: false,
          animate_screen_Reminder: true
        }));
        submitAppointment();
      }, 1000);
    }
  };

  // const updateAppointment = () => {
  //   const reminderType = state.reminderType;
  //   const locationID = state.locationID;
  //   const provider = state.provider;
  //   const appointmentTimestamp = state.appointmentTimestamp;
  //   const contactValue = state.contactValue;

  //   props.f_UPDATE_Appointment(
  //     reminderType,
  //     appointmentTimestamp,
  //     locationID,
  //     provider,
  //     contactValue
  //   );
  // };

  const handle_Change_Checkbox = name => event => {
    event.persist();
    setState(prevState => ({ ...prevState, [name]: event.target.checked }));
  };

  const onChangeRecaptcha = value => {
    if (value) {
      setState(prevState => ({
        ...prevState,
        recaptcha: true,
        errorMsgInfo: null
      }));
    }
  };

  const handle_Change_Fields = e => {
    e.persist();
    setState(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
  };

  const handle_Change_PreferredLanguage = e => {
    e.persist();
    setState(prevState => ({
      ...prevState,
      applicant_preferred_language: e.target.value
    }));
  };

  const handle_Change_PhoneNumber = e => {
    e.persist();
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    setState(prevState => ({
      ...prevState,
      applicant_phone: formattedPhoneNumber
    }));
  };

  const handle_dialog_ConfirmedMessage_Close = () => {
    setState(prevState => ({
      ...prevState,
      screen_Schedule: false,
      animate_screen_Reminder: true,
      state_dialog_ConfirmedMessage: false
    }));
  };

  useEffect(
    () => {
      if (state.screen_Reminder && !state.state_dialog_ConfirmedMessage) {
        const timeoutId = setTimeout(() => {
          window.location = "./";
        }, 1000 * 10);

        return () => clearTimeout(timeoutId);
      }
    },
    [state.screen_Reminder, state.state_dialog_ConfirmedMessage]
  );

  return (
    <Fragment>
      <div className="scheduleDialog_Wrapper" id="scheduleDialog_Wrapper">
        <div className="mainHeader modalHeaderHelper">
          <div className="topHeader">
            <div className="topHeaderInner">
              <h1>Schedule appointment</h1>
              <a href="./">
                <div className="logo logoScheduleWhite" />
              </a>
            </div>
          </div>
        </div>
        {state.screen_Schedule && (
          <div className="dialogScheduleBox">
            <div className="_dialog_infoSection">
              <div
                className={`_dialog_infoSection_inner ${state.animate_screen_Schedule &&
                  "animate_hide"}`}
              >
                <button className="_dialog_btnBack" onClick={props.onClose}>
                  <SvgIconDefaultArrow />
                  <span>Back</span>
                </button>

                <div className="_dialog_infoSection_Title">
                  Yay! You’re almost to the finish line!
                </div>

                <div className="_dialog_infoSection_Details bringinFriend">
                  <div className="svgIconContainer">
                    <SvgIconUsers />
                  </div>
                  <p>
                    {props.selectedSlotData.onehour === true
                      ? "Me + a friend"
                      : "Just me"}
                  </p>
                </div>

                <div className="_dialog_infoSection_Details appointmentDate">
                  <div className="svgIconContainer">
                    <SvgIconCalendar />
                  </div>
                  <p>
                    {moment(props.selectedSlotData.durationStart).format(
                      "dddd, MMMM DD"
                    )}
                  </p>
                </div>

                <div className="_dialog_infoSection_Details appointmentTime">
                  <div className="svgIconContainer">
                    <SvgIconTime />
                  </div>
                  <p>
                    {moment(props.selectedSlotData.durationStart).format(
                      "hh:mm A"
                    )}
                  </p>
                </div>
                <div className="_dialog_infoSection_Details appointmentProvider">
                  <div className="svgIconContainer">
                    <SvgIconStethoscope />
                  </div>
                  <p className="appointmentProviderName">
                    {props.selectedSlotData.providerName}
                  </p>

                  <div
                    className="providerImage"
                    style={{
                      backgroundImage: `url(${
                        props.selectedSlotData.providerImage
                      })`
                    }}
                  />
                </div>

                <Divider />

                <div className="requiredFieldText">* Required fields</div>

                <form>
                  <FormControl style={{ width: "100%" }}>
                    <FormGroup className="_dialog_CheckBoxesGroup">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={state.checked_info}
                            onChange={handle_Change_Checkbox("checked_info")}
                            value="checked_info"
                            classes={{
                              checked: "checked"
                            }}
                          />
                        }
                        label="Yes, this information is correct."
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={state.checked_age}
                            onChange={handle_Change_Checkbox("checked_age")}
                            value="checked_age"
                            classes={{
                              checked: "checked"
                            }}
                          />
                        }
                        label="Yes, I am 13-24 years old."
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={state.checked_in_colorado}
                            onChange={handle_Change_Checkbox(
                              "checked_in_colorado"
                            )}
                            value="checked_in_colorado"
                            classes={{
                              checked: "checked"
                            }}
                          />
                        }
                        label="I am in Colorado right now."
                      />
                      <FormControlLabel
                        sx={{
                          m: 0,
                          "& .MuiFormControlLabel-asterisk": { display: "none" }
                        }}
                        control={
                          <Checkbox
                            checked={state.consent_forms}
                            onChange={handle_Change_Checkbox("consent_forms")}
                            value="consent_forms"
                            required
                            classes={{
                              checked: "checked"
                            }}
                          />
                        }
                        label={
                          <>
                            I agree to the{" "}
                            <span
                              style={{
                                color: "#f68427",
                                textDecoration: "none"
                              }}
                              onClick={openDialog}
                            >
                              acknowledgment and consent forms
                            </span>
                            .
                          </>
                        }
                      />
                    </FormGroup>
                  </FormControl>
                  <FormControl style={{ width: "100%" }}>
                    <FormGroup className="_dialog_InputGroup">
                      <InputLabel htmlFor="name-simple">
                        First Name or Nickname
                      </InputLabel>
                      <Input
                        id="name-simple"
                        name="applicant_nickname"
                        onChange={e => handle_Change_Fields(e)}
                        fullWidth
                      />
                    </FormGroup>
                  </FormControl>
                  <FormGroup className="_dialog_InputGroup">
                    <div style={{ marginTop: "16px" }}>
                      <input
                        onChange={handle_Change_PhoneNumber}
                        value={state.applicant_phone}
                        placeholder="Phone Number"
                      />
                    </div>
                  </FormGroup>
                  <FormControl style={{ width: "100%" }}>
                    <FormGroup className="_dialog_InputGroup">
                      <select
                        onChange={handle_Change_PreferredLanguage}
                        value={state.applicant_preferred_language}
                        style={{ marginTop: "16px" }}
                        id="language"
                      >
                        <option>English</option>
                        <option>Spanish</option>
                        <option>Other</option>
                      </select>
                    </FormGroup>
                  </FormControl>
                  {state.applicant_preferred_language === "Other" && (
                    <FormControl style={{ width: "100%" }}>
                      <FormGroup className="_dialog_InputGroup">
                        <InputLabel htmlFor="language">
                          Other Language
                        </InputLabel>
                        <Input
                          id="language"
                          name="other_preferred_language"
                          onChange={e => handle_Change_Fields(e)}
                          fullWidth
                        />
                      </FormGroup>
                    </FormControl>
                  )}

                  <div className="g-recaptcha-wrapper">
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={REACT_APP_RECAPTCHA_KEY}
                      onChange={onChangeRecaptcha}
                    />
                  </div>

                  {state.rField && (
                    <div className="warningContainer">
                      <p>{state.rField}</p>
                    </div>
                  )}

                  <Button
                    className="_dialog_DefaultButton"
                    variant="outlined"
                    component="span"
                    onClick={dialogChooseReminder}
                  >
                    Schedule Appointment
                  </Button>
                </form>
              </div>
            </div>
          </div>
        )}
        {state.screen_Reminder && (
          <div className="dialogScheduleBox">
            <div className="_dialog_reminderSection">
              <div
                className={`_dialog_reminderSection_inner ${state.animate_screen_Reminder &&
                  "animate_show"}`}
              >
                <div className="wrapperProvInfo _provInfoTitle">
                  <div className="_dialog_youDidIt">
                    <h1>YOU DID IT!</h1>
                  </div>
                  <div className="screenshotReminder">
                    (Take a screenshot of this page to remember your appointment
                    date or set a reminder below)
                  </div>
                  <div className="_dialog_infoSection_Title">
                    Your appointment details:
                  </div>

                  <div className="_dialog_infoSection_Details bringinFriend">
                    <div className="svgIconContainer">
                      <SvgIconUsers />
                    </div>
                    <p>
                      {props.selectedSlotData.onehour === true
                        ? "Me + a friend"
                        : "Just me"}
                    </p>
                  </div>

                  <div className="_dialog_infoSection_Details appointmentDate">
                    <div className="svgIconContainer">
                      <SvgIconCalendar />
                    </div>
                    <p>
                      {moment(props.selectedSlotData.durationStart).format(
                        "dddd, MMMM DD"
                      )}
                    </p>
                  </div>

                  <div className="_dialog_infoSection_Details appointmentTime">
                    <div className="svgIconContainer">
                      <SvgIconTime />
                    </div>
                    <p>
                      {moment(props.selectedSlotData.durationStart).format(
                        "hh:mm A"
                      )}
                    </p>
                  </div>
                  <div className="_dialog_infoSection_Details appointmentProvider">
                    <div className="svgIconContainer">
                      <SvgIconStethoscope />
                    </div>
                    <p className="appointmentProviderName">
                      {props.selectedSlotData.providerName}
                    </p>

                    <div
                      className="providerImage"
                      style={{
                        backgroundImage: `url(${
                          props.selectedSlotData.providerImage
                        })`
                      }}
                    />
                  </div>
                </div>
                <div className="reminderSocial_Wrapper">
                  <Dialog
                    className="_ConfirmDialog_Outer"
                    open={state.state_dialog_ConfirmedMessage}
                    TransitionComponent={Transition}
                    aria-labelledby="form-dialog-title"
                  >
                    <div className="_ConfirmDialog_Inner">
                      <p>
                        A provider will call you within 30 minutes of your
                        scheduled phone appointment time. Watch for a call from
                        a number that starts with 720-777-xxxx. That will be us!
                      </p>
                      <Button
                        className="_dialogSubmit _okThanks"
                        onClick={handle_dialog_ConfirmedMessage_Close}
                        color="primary"
                      >
                        Continue
                      </Button>
                    </div>
                  </Dialog>
                </div>
              </div>
            </div>
          </div>
        )}
        <Dialog
          open={showDialog}
          onClose={closeDialog}
          style={{ marginTop: "70px" }}
          fullScreen={fullScreen}
        >
          <DialogContent>
            {/* eslint-disable-next-line */}
          <img
           style={{
                position: "absolute",
                top: "2rem",
                right: "2rem",
                cursor: "pointer",
                "&:hover": {
                  transform: "scale(1.2)"
                }}}
            onClick={closeDialog}
            src={closeButtonImg}
            alt="close-button"
          />
            <Consent />
            <div>
              <Button
      variant="contained"
      disableRipple
      onClick={() => {
                  closeDialog();
                }}
      style={{
        backgroundColor: "#8cbf34",
        color: "#fff",
        textTransform: "none",
        fontFamily: '"Roboto", sans-serif',
        fontWeight: 600,
        fontSize: "20px",
        padding: "8px 24px",
        borderRadius: "8px",
        boxShadow: "none",
        width: "100%"
      }}
      sx={{
        "&:hover": {
          backgroundColor: "#8cbf34",
          opacity: 0.9,
        },
        "& span.MuiButton-label": {
          "@media screen and (max-width: 545px)": {
            fontSize: "18px",
          },
        },
      }}
              >
                OK
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </Fragment>
  );
}

function mapStateToProps(state) {
  return {
    DATA_fetch_providersImage: state.DATA_fetch_providersImage,
    DATA_fetch_appointment: state.DATA_fetch_appointment,
    dataFetchTimeslots: state.dataFetchTimeslots
  };
}

// for redux dispatch
function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

// for redux
export default connect(mapStateToProps, mapDispatchToProps)(
  SoonestSlotsProvidersDialog
);
